<template>
  <div class="peer-page-container">
    <div class="img-box" v-for="(item, idx) in imgList" :key="idx">
      <img v-if="idx === 1" class="qrcode" :src="qrcodeUrl" alt="" />
      <img :src="item" alt="" srcset="" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import useQrcode from '@/hooks/useQrCode'
import { decrypt } from '@/utils/decryptQrc'

const store = useStore()
const route = useRoute()
const imgList = ref([])
const { qrcodeUrl, fetchQrcode } = useQrcode()

const getVasterPosition = async (pageCode) => {
  const { code, data } = await store.dispatch('getVasterPosition', { pageCode })
  if (code === 1) {
    try {
      imgList.value = JSON.parse(data?.image)
    } catch (err) {
      // do nothing
    }
  }
}

onMounted(() => {
  getVasterPosition(route.query?.pageCode)
  if (route.query.imgUrl) {
    qrcodeUrl.value = decrypt(route.query.imgUrl)
    return
  }
  fetchQrcode(10744, true)
})
</script>

<style lang="stylus" scoped>
.peer-page-container {
  font-size: 0;
  .img-box {
    position relative
    .qrcode {
      position: absolute
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50%;
    }
    img {
      width: 100%;
    }
  }
}
</style>
